import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ContainerBase } from '../../../core/base/container-base'

import * as fromOrderHistory from '../../reducers'
import * as fromAuth from '../../../auth/reducers'

import * as orderhistory from '../../actions/order-history.actions'

import { OrderHistory } from '../../models/orderhistory'

@Component({
  selector: 'app-orderhistory-page-container',
  templateUrl: './orderhistory-page-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderhistoryPageContainerComponent extends ContainerBase implements OnInit {
  orderHistory$: Observable<OrderHistory[]>
  loading$: Observable<boolean>
  expanding$: Observable<boolean>
  currency$: Observable<string>;

  constructor(
    private store: Store<fromOrderHistory.State>
  ) {
    super()

    // Observables
    this.orderHistory$ = store.pipe(
      select(fromOrderHistory.getOrderHistory),
      takeUntil(this.destroyed$)
    )

    this.loading$ = store.pipe(
      select(fromOrderHistory.getOrderHistoryLoading),
      takeUntil(this.destroyed$)
    )

    this.expanding$ = store.pipe(
      select(fromOrderHistory.getOrderHistoryExpanding),
      takeUntil(this.destroyed$)
    )

    this.currency$ = store.pipe(
      select(fromAuth.getCurrency),
      takeUntil(this.destroyed$)
    )
   }

   ngOnInit() {
     this.store.dispatch(new orderhistory.LoadOrderHistory())
   }

  expand() {
    this.store.dispatch(new orderhistory.LoadOrderHistoryExpand())
  }
}
